<template>
  <div class="p-0 col-12 animated fadeIn">
    <div class="card">
      <div class="card-body">
        <div class="form form-horizontal" style="margin: 15px;">
          <div class="form-group row">
            <label class="col-4 col-md-3 col-lg-2">ID Number</label>
            <div class="p-0 select col-8 col-md-9 col-lg-10">
              <input type="text" v-model="partner.idnumber" class="form-control" placeholder="Dropshiper / Reseller ID Number"/>
            </div>
          </div>
          <div class="form-group row">
            <label class="col-4 col-md-3 col-lg-2">Full Name</label>
            <div class="p-0 select col-8 col-md-9 col-lg-10">
              <input type="text" v-model="partner.name" class="form-control" placeholder="Dropshiper / Reseller Name"/>
              <small v-bind:class=" { 'd-none': verification.name } " class="form-feedback error">This field is required</small>
            </div>
          </div>
          <div class="form-group row">
            <label class="col-4 col-md-3 col-lg-2">Phone<span class="d-none d-md-inline"> Number</span></label>
            <div class="col-8 col-md-9 col-lg-10 p-0">
              <kendo-maskedtextbox title="phone number" v-model="partner.phone" mask="0000-0000-00000" class="form-control" placeholder="Dropshipper / Reseller Phone Number"></kendo-maskedtextbox>
              <small v-bind:class=" { 'd-none': verification.phone } " class="form-feedback error">This field is required</small>
            </div>
          </div>
          <div class="form-group row">
            <label class="col-4 col-md-3 col-lg-2">Email</label>
            <div class="col-8 col-md-9 col-lg-10 p-0">
              <input type="email" v-model="partner.email" class="form-control" placeholder="Dropshipper / Reseller Email"/>
              <small v-bind:class=" { 'd-none': verification.email } " class="form-feedback error">This field is required</small>
            </div>
          </div>
          <div class="form-group row">
            <label class="col-4 col-md-3 col-lg-2">City</label>
            <div class="col-8 col-md-9 col-lg-10 p-0">
              <vue-google-autocomplete ref="mapautocomplete" id="map2" classname="form-control" placeholder="Customer Address" 
                v-on:placechanged="getCityData" :country="'id'" types="(cities)">
              </vue-google-autocomplete>
              <small v-bind:class=" { 'd-none': verification.city } " class="form-feedback error">This field is required</small>
            </div>
          </div>
          <div class="form-group row">
            <label class="col-4 col-md-3 col-lg-2">Address</label>
            <div class="col-8 col-md-9 col-lg-10 p-0">
              <vue-google-autocomplete ref="mapautocomplete" id="map" classname="form-control" placeholder="Customer Address" 
                v-on:placechanged="getAddressData" :country="'id'"
                v-on:change="addressChange">
              </vue-google-autocomplete>
              <small v-bind:class=" { 'd-none': verification.address } " class="form-feedback error">This field is required</small>
              <small v-bind:class=" { 'd-none': verification.places } " class="form-feedback error">Address not found. Please search the nearest location for the address!</small>
            </div>
          </div>
          <div class="form-group row">
            <label class="col-4 col-md-3 col-lg-2">Notes</label>
            <div class="col-8 col-md-9 col-lg-10 p-0">
              <textarea v-model="partner.notes" class="form-control" placeholder="Notes"></textarea>
            </div>
          </div>
          <!-- <div class="form-group row">
            <label class="col-4 col-md-3 col-lg-2">ID File</label>
            <input type="file" />
          </div> -->
        </div>
      </div>
    </div>
    <div class="col-12 text-right p-0">
      <button class="btn btn-primary" @click="submit"><i class="fa fa-save"></i>&nbsp;&nbsp;ADD PARTNER</button>
    </div>
  </div>
</template>

<script>
import VueGoogleAutocomplete from 'vue-google-autocomplete'

export default {
  data () {
    return {
      partner: {
        idnumber: null,
        name: null,
        phone: null,
        email: null,
        address: null,
        places: null,
        notes: null,
        city: null
      },
      verification: {
        name: true,
        phone: true,
        email: true,
        address: true,
        places: true,
        city: true
      }
    }
  },
  components: {
    VueGoogleAutocomplete
  },
  methods: {
    addressChange (event) {
      this.partner.address = event
    },
    getAddressData (addressData, placeResultData, id) {
      this.partner.places = {
        address_components: placeResultData.address_components,
        formatted_address: placeResultData.formatted_address,
        url: placeResultData.url
      }
      console.log(this.partner)
    },
    getCityData (addressData, placeResultData, id) {
      this.partner.city = {
        address_components: placeResultData.address_components,
        formatted_address: placeResultData.formatted_address
      }
      console.log(this.partner)
    },
    submit () {
      // verifiy form
      if (this.doVerification()) {
        // do actual submit
        var data = new URLSearchParams()
        data.append('name', this.partner.name)
        data.append('phone', this.partner.phone)
        data.append('email', this.partner.email)
        data.append('city', JSON.stringify(this.partner.city))
        data.append('address', this.partner.address)
        data.append('places', JSON.stringify(this.partner.places))
        data.append('notes', this.partner.notes)

        var vm = this
        vm.axios.post('api/user/partner/', data)
          .then(
            (response) => {
              console.log(response)
              vm.$parent.showNotification('Dropshipe / Reseller ' + vm.partner.name + ' successfully added', 'success')
              vm.$router.push('/customer/partners')
            }
          )
          .catch(
            (error) => {
              console.log(error.response)
            }
          )
      }
    },
    doVerification () {
      if (this.partner.name === null || (this.partner.name !== null && this.partner.name.length === 0)) {
        this.verification.name = false
        return false
      } else {
        this.verification.name = true
      }
      if (this.partner.phone === null || (this.partner.phone !== null && this.partner.phone.length === 0)) {
        this.verification.phone = false
        return false
      } else {
        this.verification.phone = true
      }
      if (this.partner.email === null || (this.partner.email !== null && this.partner.email.length === 0)) {
        this.verification.email = false
        return false
      } else if (this.partner.email !== null && !this.verifyEmail(this.partner.email)) {
        this.verification.email = false
        return false
      } else {
        this.verification.email = true
      }
      if (this.partner.city === null || (this.partner.city !== null && 'address_components' in this.partner.city && this.partner.city.length === 0)) {
        this.verification.city = false
        return false
      } else {
        this.verification.city = true
      }
      if (this.partner.places === null || (this.partner.places !== null && this.partner.places.length === 0)) {
        this.verification.places = false
        return false
      } else {
        this.verification.places = true
      }
      if (this.partner.address === null || (this.partner.address !== null && this.partner.address.length === 0)) {
        this.verification.address = false
        return false
      } else {
        this.verification.address = true
      }
      return true
    },
    verifyEmail (email) {
      var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@(([[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return re.test(String(email).toLowerCase())
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/customer/partners/AddPartner.vue